import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { backgroundColorOptions, getColorOptions } from '../../../utils/chartsData';

import styles from '../headerBtn.module.scss';
import clsx from 'clsx';

interface IOptions {
  dataCharts: {
    type: string;
    labels: string[];
    isVisiblelabel: string[];
  },
  setSelectedSettings: (data: string[]) => void,
  setIsHasShadowList: (data: string[]) => void,
};

const ChangeColorSection: FC<IOptions> = ({ dataCharts, setSelectedSettings, setIsHasShadowList }) => {
  const { settingCharts } = useSelector((state: any) => state.charts?.chartsList);

  const colorsPalette = getColorOptions(settingCharts?.[dataCharts.type]);
  const colorCount = dataCharts.labels.length || 0;
  const hasShadow = settingCharts?.hasShadow || [];
  const [isCheckShadow, setIsCheckShadow] = useState<boolean>(hasShadow.includes(dataCharts.type));

  const [colorsList, setColorsList] = useState<string[]>(colorsPalette);

  const handleChangeColorPicker = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const color = event?.target?.value;
    const newSelectedColors = [...colorsList];
    newSelectedColors[index] = color;

    setColorsList(newSelectedColors);
    setSelectedSettings(newSelectedColors);
  };

  const handleClickReset = () => {
    setIsCheckShadow(false);
    if (hasShadow && hasShadow.includes(dataCharts.type)) {
      const filteredArr = hasShadow.filter((el: string) => el !== dataCharts.type);
      setIsHasShadowList(filteredArr);
    } else {
      setIsHasShadowList([...hasShadow, dataCharts.type]);
    }
    setColorsList(backgroundColorOptions.slice(0, colorCount));
    setSelectedSettings(backgroundColorOptions.slice(0, colorCount));
  };

  const handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsCheckShadow(e.target.checked);
    if (hasShadow && hasShadow.includes(dataCharts.type)) {
      const filteredArr = hasShadow.filter((el: string) => el !== dataCharts.type);
      setIsHasShadowList(filteredArr);
    } else {
      setIsHasShadowList([...hasShadow, dataCharts.type]);
    }
    setSelectedSettings([...colorsList]);
  };

  useEffect(() => {
    setIsHasShadowList(hasShadow);
    setSelectedSettings([...colorsList]);
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.block__info}>
      <div className='charts__header'>
        <div className={clsx(styles.check__list_elem, styles.check__list_elem_noBorder)}>
          <label className={styles.checkbox__container}>
            <input
              checked={isCheckShadow}
              type='checkbox'
              onChange={handleChangeCheckbox}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Добавить тень
        </div>
        <button onClick={handleClickReset} className='reset-btn reset-btn_colors'>Установить по умолчанию</button>
      </div>
      <div className='charts__filters'>
        {dataCharts.labels.map((label: string, index: number) => {
          const visible = dataCharts.isVisiblelabel.includes(label) ? 'flex' : 'none';

          return (
            <div className={clsx(
              styles.limit__block,
              styles.limit__block_center,
              styles.limit__block_colors
            )}
              key={index}
              style={{ display: `${visible}` }}
            >
              <div className='color__selector color__elem' style={{ backgroundColor: `${colorsList[index]}` }}></div>
              <label className='color__selector color__selector_modal'>
                <span>Выберите цвет</span>
                <input
                  onChange={(e) => handleChangeColorPicker(e, index)}
                  value={colorsList[index]}
                  className='color__picker'
                  type='color'
                />
              </label>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default ChangeColorSection;
